const getTitleCase = str => str && str.toLowerCase().replace(/(^|\s)([a-z])/g, searchValue => searchValue.toUpperCase());
export const getLocationString = (city, state, zipcode) => {
  const cityString = city ? `${getTitleCase(city)}, ` : '';
  const stateString = state ? `${state} ` : '';
  return cityString + stateString + zipcode;
};